import { useEffect, useState } from 'react';

const DelayedMount = ({ children, fallback = null }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const frameId = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setShow(true);
      });
    });
    return () => cancelAnimationFrame(frameId);
  }, []);

  return show ? children : fallback;
};

export default DelayedMount;
